<template>
    <div :class="['form', 'form__image', disabled ? 'form__image--disabled' : '']">
        <div
            v-if="label"
            class="form__image_title"
        >{{label | toCapitalize}}<span class="asterisk" v-if="required">*</span></div>
        <div class="form__image_box">
            <div
                :class="['form__image_box_field', errors.first(toKebabCase(name)) ? `form__image_box_field--overlay` : '']"
            >
                <div class="columns fullheight is-vcentered">
                    <div class="column custom--center">
                        <div class="form__image_box_field_placeholder">
                            <p class="form__image_box_field_placeholder_secondline">{{ $t('forms.image.title.clickTheButton') }}</p>
                            <p class="form__image_box_field_placeholder_thirdline">
                                <component-button
                                    :theme="'default'"
                                    :name="'form-image-box-field-placeholder-thirdline-button'"
                                    :disabled="disabled"
                                    @click="openPopLibrary"
                                >{{ files.length ? $t('forms.image.buttons.change') : $t('forms.image.buttons.select')}}
                                </component-button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form__image_box_input">
                <input
                    type="text"
                    :name="name | toKebabCase"
                    :id="'form-image-' + name"
                    :value="value"
                    :v-validate="vValidate"
                    :disabled="disabled"
                >
                <span
                    class="form__error form__image_error"
                    v-if="errors.first(toKebabCase(name))"
                >{{ $t('forms.image.title.PleaseEnsureUploaded') }}</span>
            </div>
        </div>
        <div class="form__image_gallery" v-if="value && value.length">
            <div class="columns is-multiline">
                <div
                    class="column is-4-desktop is-12-tablet is-12-mobile"
                    v-for="(thumbnail, index) in thumbnails"
                    :key="index"
                >
                    <div class="form__image_gallery_image">
                        <div class="form__image_gallery_image_actions">
                            <div class="columns is-variable">
                                <div class="column is-narrow">
                                    <component-button
                                        :classes="'btn--white'"
                                        :icon="true"
                                        :icon-name="'eye'"
                                        :name="'form-image-gallery-image-actions-eye'"
                                        @click="openPopImage(thumbnail)"
                                    />
                                </div>
                                <template v-if="!disabled">
                                    <div class="column is-narrow">
                                        <component-button
                                            :classes="'btn--white'"
                                            :icon="true"
                                            :icon-name="'trash-2'"
                                            :name="'form-image-gallery-image-actions-trash'"
                                            :disabled="disabled"
                                            @click="openNotifyRemoveImage(index)"
                                        />
                                    </div>
                                </template>
                            </div>
                        </div>
                        <component-image
                            :id="thumbnail"
                            :clickable="false"
                        ></component-image>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="$slots.default">
            <div class="form__image_hint">
                <slot></slot>
            </div>
        </template>
        <pop-image ref="popimage"/>
        <pop-notify
            ref="popnotifyremove"
            :class="'pop__notify--remove-image'"
            :title-text="$t('forms.image.notify.titleRemove')"
            :content-text="$t('forms.image.notify.contentRemove')"
            :submit-button-text="$t('forms.image.notify.remove')"
            :submit-button-danger="true"
            :cancel-button-text="$t('forms.image.notify.cancel')"
            @emit-submit="removeImage"
        />
        <pop-side
            ref="poplibraryouter"
            :title="'Media library'"
            :custom-button-active="!customerId"
            :custom-button-to="{ name: 'media-library-list' }"
            :custom-button-text="'Go to media library'"
            :primary-button-text="'Select'"
            :secondary-button-active="!customerId"
            :secondary-button-text="'Upload'"
            :secondary-button-theme="'default'"
            :secondary-button-icon="true"
            :secondary-button-icon-name="'upload'"
            @emit-secondary="openFileUploader"
            @emit-primary="emitSelectFiles"
        >
            <pop-side-library
                ref="poplibrary"
                :customer-id="customerId"
                :allow-multiple="allowMultiple"
                :formats="formats"
            />
        </pop-side>
    </div>
</template>

<script>
import PopImage from '@/components/default/shared/PopImage'
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentButton from '@/components/default/shared/ComponentButton'
import PopSideLibrary from '@/components/default/shared/PopSideLibrary'
import PopSide from '@/components/default/shared/PopSide'
import ComponentImage from '@/components/default/shared/ComponentImage'

export default {
  components: {
    ComponentImage,
    PopSide,
    PopSideLibrary,
    ComponentButton,
    PopNotify,
    PopImage
  },
  name: 'form-image',
  data () {
    return {
      newImageData: '',
      imageReader: '',
      files: '',
      images: ''
    }
  },
  props: {
    allowMultiple: {
      type: Boolean
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: 'Label'
    },
    required: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    value: {
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    },
    vValidate: {
      type: String
    },
    customerId: {
      type: String
    },
    formats: {
      type: String
    }
  },
  computed: {
    thumbnails () {
      if (this.value.constructor === Array) {
        return this.value.map(item => {
          return item.fileId || item.imageId
        })
      } else {
        return [this.value]
      }
    }
  },
  methods: {
    openPopLibrary () {
      this.$refs.poplibraryouter.openPop()
    },
    closePopLibrary () {
      this.$refs.poplibraryouter.closePop()
    },
    openNotifyRemoveImage: function (index) {
      this.$refs.popnotifyremove.openNotify()
      this.$refs.popnotifyremove.customValue = index
    },
    openPopImage: function (image) {
      this.$refs.popimage.openNotify()
      this.$refs.popimage.setId(image)
    },
    openFileUploader () {
      this.$refs.poplibrary.openFileUploader()
    },
    emitSelectFiles () {
      this.$emit('emit-select', this.$refs.poplibrary.$refs.componentlibrary.selected)
      this.closePopLibrary()
    },
    removeImage: function (key) {
      this.$emit('emit-remove', key)
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formimage";
</style>
